/// <reference path="../types.d.ts" />
import React from 'react';

// Access the build config from the global window object
declare global {
  interface Window {
    BUILD_CONFIG?: {
      BUILD_ID?: string;
      DATADOG_ID?: string;
      PUBLIC_URL: string;
      GRID_LICENSE_KEY?: string;
      LICENSE_STORAGE_KEY?: string;
      gitInfo: {
        sha?: string;
        abbreviatedSha?: string;
        branch?: string;
        tag?: string | null;
      };
      UI_VERSION: string;
    };
  }
}

const buildConfig = window.BUILD_CONFIG || {
  PUBLIC_URL: '',
  gitInfo: { branch: 'unknown', sha: 'unknown' },
  UI_VERSION: '0.0.0',
  GRID_LICENSE_KEY: '',
};

console.log('UI Version:', buildConfig.UI_VERSION);
console.log('Git Info:', buildConfig.gitInfo);
console.log('Public URL:', buildConfig.PUBLIC_URL);

export const gitInfo = {
  branch: `${buildConfig.gitInfo.branch || 'unknown'}`,
  commit: `${buildConfig.gitInfo.abbreviatedSha || buildConfig.gitInfo.sha || 'unknown'}`
};

export const GitTag = () => {
  return (
    <div id="buildInfo" style={{ display: 'none' }}>
      <div>Branch: {gitInfo.branch}</div>
      <div>Tag: {gitInfo.commit}</div>
    </div>
  );
};
